import styled, { css } from 'styled-components';

export const GroupCreateNewPodPlus = styled.div<{ $isLoading?: boolean }>`
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.1);
    border: 2px solid rgba(255, 255, 255, 0.5);
    border-radius: 30px;

    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 20px;
        height: 20px;
    }

    ${({ $isLoading }) =>
        $isLoading &&
        css`
            svg {
                width: 16px;
                height: 16px;
            }
        `};
`;

export const GroupCreateNewPodText = styled.div`
    font-weight: 600;
    font-size: 18px;
    line-height: 20px;
    letter-spacing: -0.03em;
`;
